export default __webpack_public_path__ + "static/media/dumpster-rental.f9244710.svg";